module.exports = __webpack_public_path__ + "img/Assistance_white.9b5a7558.svg";